var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 15.75V17.1562C11.4286 17.6484 11.0357 18 10.5714 18H0.857143C0.357143 18 0 17.6484 0 17.1562V4.21875C0 3.76172 0.357143 3.375 0.857143 3.375H3.42857V13.7812C3.42857 14.8711 4.32143 15.75 5.42857 15.75H11.4286ZM11.4286 3.65625C11.4286 4.14844 11.7857 4.5 12.2857 4.5H16V13.7812C16 14.2734 15.6071 14.625 15.1429 14.625H5.42857C4.92857 14.625 4.57143 14.2734 4.57143 13.7812V0.84375C4.57143 0.386719 4.92857 0 5.42857 0H11.4286V3.65625ZM15.7143 2.56641C15.8929 2.74219 16 2.95312 16 3.16406V3.375H12.5714V0H12.7857C13 0 13.2143 0.105469 13.3929 0.28125L15.7143 2.56641Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocMenuIcon);
export default __webpack_public_path__ + "static/media/doc-menu-icon.e681c644dc20fc983129a0ca8e71a9ac.svg";
export { ForwardRef as ReactComponent };